<template>
  <div>
    <v-fab-transition>
      <v-btn
        :class="marginTop"
        :color="color ? color : getThemeColor"
        dark
        absolute
        top
        right
        fab
        @click="$emit('button-clicked')"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
export default {
  props: ["color", "marginTop"],

  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
};
</script>

<style></style>
